import printJS from 'print-js';

export default class BrixTable {
  static init(...parameters) {
    return new BrixTable(...parameters);
  }

  constructor(block) {
    const printButton = block.querySelector('.print-button');

    if (printButton) {
      printButton.addEventListener('click', () => {
        printJS({
          printable: block.id,
          type: 'html',
          maxWidth: '100%',
          style: '.print-logo-wrapper {width: 20%; height: auto; margin-bottom: 24pt} .print-button, .updated-text {display: none} .table {font-family: sans-serif; border-collapse: collapse;} .table td, .table th {border: 1px solid; font-size: 16pt; text-align: left; padding: 10px;} .table caption {caption-side: bottom; text-align: left; margin-top: 16pt;}',
          scanStyles: false,
          documentTitle: block.dataset.documentTitle,
        });
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-table', BrixTable.init);
}
